jQuery(function ($) {
  // ハンバーガーメニュー
  $(function () {
      $(".js-hamburger").click(function () {
          $(this).toggleClass("is-open");
          $(".js-drawer").fadeToggle();
      });

      // ドロワーナビのaタグをクリックで閉じる
      $(".js-drawer a[href]").on("click", function () {
          $(".js-hamburger").removeClass("is-open");
          $(".js-drawer").fadeOut();
      });

      // resizeイベント
      $(window).on('resize', function() {
          if (window.matchMedia("(min-width: 768px)").matches) {
              $(".js-hamburger").removeClass("is-open");
              $(".js-drawer").fadeOut();
          }
      });
  });
});

$(function () {
    const pageTop = $(".js-page-top");
    pageTop.click(function () {
      $("body, html").animate(
        {
          scrollTop: 0,
        },
        300
      );
      return false;
    });
  });

  $(function () {
    const pageTop = $(".js-cta");
    pageTop.hide();
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      const windowHeight = $(this).height();
      const documentHeight = $(document).height();
      const isBottom = scrollTop + windowHeight >= documentHeight - 200;
      if (!isBottom) {
        if (scrollTop > 100 && pageTop.is(":hidden")) {
          pageTop.fadeIn();
        }
        else if (scrollTop <= 100 && pageTop.is(":visible")) {
          pageTop.fadeOut();
        }
      } else {
        if (pageTop.is(":visible")) {
          pageTop.fadeOut();
        }
      }
    });
  });

  jQuery(function ($) {
    $('.js-faq-question').on('click', function () {
        $(this).next().slideToggle();
        $(this).toggleClass('is-open');
    });
});

jQuery(function ($) {
  const swiper = new Swiper(".js-voice-swiper", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true, 
    },
  });
});